export class CardTransactionDetails {
  creationDate: string;
  postingDate: string;
  merchantName: string;
  merchantType: string;
  status: string;
  rrn: string;
  amount: number;
  currencyShortDescription: string;
  countryCode: string;
  transactionValue?: number;
  transactionValueCurrencyShortDescription?: string;
  cardNumber?: string;

  constructor(
    creationDate: string,
    postingDate: string,
    merchantName: string,
    merchantType: string,
    status: string,
    rrn: string,
    amount: number,
    currencyShortDescription: string,
    countryCode: string,
    transactionValue?: number,
    transactionValueCurrencyShortDescription?: string,
    cardNumber?: string,
  ) {
    this.creationDate = creationDate;
    this.postingDate = postingDate;
    this.merchantName = merchantName;
    this.merchantType = merchantType;
    this.status = status;
    this.rrn = rrn;
    this.amount = amount;
    this.currencyShortDescription = currencyShortDescription;
    this.countryCode = countryCode;
    this.transactionValue = transactionValue;
    this.transactionValueCurrencyShortDescription = transactionValueCurrencyShortDescription;
    this.cardNumber = cardNumber;
  }
}
